module.exports = __webpack_public_path__ + "img/dice-drawing-no-comp-2.7d142157.gif";